<template>
  <el-dialog :title="editType == 1 ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="innerVisible"
    width="700px">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="80px">
      <el-form-item label="通知标题" prop="bigHead">
        <el-input v-model="ruleForm.bigHead"></el-input>
      </el-form-item>
      <el-form-item label="通知链接" prop="link">
        <el-input v-model="ruleForm.link">
          <template slot="prepend">Http://</template>
        </el-input>
      </el-form-item>
      <div style="display: flex;flex-direction: column;">
        <div v-for="(smallHeadRow, rowIndex) in ruleForm.smallHead">
          <div style="display: flex;flex-direction: row;width: 100%;margin-bottom: 10px;">
            <div v-for="(item, listIndex) in smallHeadRow" style="width: 100%;">
              <div style="display: flex;flex-direction: row;width: 100%;">
                <div style="width: 100%;">
                  <div style="display: flex;flex: 1;flex-direction: row;">
                    <el-input v-model="item.title" :placeholder="'标题' + item.label" style="width: 100px;"></el-input>
                    <el-input v-model="item.value" placeholder="请输入内容" style="margin:0 2px;">
                    </el-input>
                    <div v-if="editType == 1"
                      style="display: flex;flex-direction: row;flex-wrap: nowrap;margin-right: 5px;">
                      <div>
                        <i v-if="smallHeadRow.length == 1" style="color: rgb(153, 153, 153);margin:0 2px;font-size: 17px;"
                          class="el-icon-circle-plus" @click="addSmallHead(rowIndex, listIndex)"></i>
                      </div>
                      <div>
                        <i style="color: rgb(153, 153, 153);margin:0 2px;font-size: 17px;" class="el-icon-remove"
                          @click="deleteSmallHead(rowIndex, listIndex)"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <el-form-item :prop="'smallHeadValue' + item.label" :margin-left="0"
                  :rules="{ required: true, message: '内容不能为空', trigger: 'blur' }">
                  <el-input v-model="item.value"></el-input>
                </el-form-item> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="zj-form-bottom" style="margin-top: 10px;">
        <el-button type="primary" @click="submitForm()">保存</el-button>
        <el-button v-if="editType == 1" @click="addSmallHead(-1, -1)">新增行</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editType: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      ruleForm: {
        notification_id: 0,
        bigHead: '',
        link: '',
        photo: '',
        smallHead: [[{ label: 1, id: '', title: '', value: '', key: Date.now() }]]
      },
      rules: {
        bigHead: [
          { required: true, message: '请输入通知标题', trigger: 'blur' },
        ],
        link: [
          { required: true, message: '请输入通知链接', trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let notification = {
            notification_head: this.ruleForm.bigHead,
            notification_photo: this.ruleForm.photo,
            notification_link: this.ruleForm.link,
            notification_show: true,
          };
          let notification_content = [];
          for (var i = 0; i < this.ruleForm.smallHead.length; i++) {
            for (var j = 0; j < this.ruleForm.smallHead[i].length; j++) {
              let content = {
                notification_id: this.notification_id,
                nc_id: this.ruleForm.smallHead[i][j].id,
                nc_title: this.ruleForm.smallHead[i][j].title,
                nc_content: this.ruleForm.smallHead[i][j].value,
                nc_sequence: j + 1,
                nc_line: i + 1,
              };
              notification_content.push(content);
            }
          };
          let model = {};
          model.notification = notification;
          model.notification_content = notification_content;
          if (this.editType == 1) {   //新增
            this.z_post(
              "api/notification/addNotification", model, { loading: true }
            ).then(res => {
              this.$message({
                message: "新增成功",
                type: "success",
                duration: 1000
              });
              this.$parent.getNotification();
              this.innerVisible = false;
            }).catch(res => {
              this.$alert("新增失败", {
                type: "warning",
                confirmButtonText: "确定"
              });
            });
          }
          else {   //编辑
            notification.notification_id = this.notification_id;
            notification.UpdateColumns = ["notification_head", "notification_sequence", "notification_photo", "notification_link", "notification_show"];
            for (var i = 0; i < model.notification_content.length; i++) {
              notification_content[i].UpdateColumns = ["nc_title", "nc_content", "nc_sequence", "nc_line"];
            }
            this.z_post(
              "api/notification/editNotification", model, { loading: true }
            ).then(res => {
              this.$message({
                message: "修改成功",
                type: "success",
                duration: 1000
              });
              this.$parent.getNotification();
              this.innerVisible = false;
            }).catch(res => {
              this.$alert("修改失败", {
                type: "warning",
                confirmButtonText: "确定"
              });
            });
          }
        }
      });
    },
    /* resetForm(formName) {
      this.$refs[formName].resetFields();
    }, */
    removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    addSmallHead(rowIndex, listIndex) {
      if (rowIndex == -1 && listIndex == -1) {
        this.ruleForm.smallHead.push([{ label: '', id: '', title: '', value: '', key: Date.now() }]);
      }
      else {
        this.ruleForm.smallHead[rowIndex].push({ label: '', id: '', title: '', value: '', key: Date.now() });
      }
      let label = 1;
      for (var i = 0; i < this.ruleForm.smallHead.length; i++) {
        for (var j = 0; j < this.ruleForm.smallHead[i].length; j++) {
          this.ruleForm.smallHead[i][j].label = label;
          label = label + 1;
        }
      }
    },
    deleteSmallHead(rowIndex, listIndex) {
      if (this.ruleForm.smallHead[rowIndex].length == 1) {
        this.ruleForm.smallHead.splice(rowIndex, 1);
      }
      else {
        this.ruleForm.smallHead[rowIndex].splice(listIndex, 1);
      }
      let label = 1;
      for (var i = 0; i < this.ruleForm.smallHead.length; i++) {
        for (var j = 0; j < this.ruleForm.smallHead[i].length; j++) {
          this.ruleForm.smallHead[i][j].label = label;
          label = label + 1;
        }
      }
    },
    getNotification(notification_id) {
      this.notification_id = notification_id;
      this.z_get(
        "api/notification/getOneNotification", { notification_id: notification_id }, { loading: true }
      ).then(res => {
        let notificationData = res.data;
        this.ruleForm.notification_id = notificationData[0].notification_id;
        this.ruleForm.bigHead = notificationData[0].notification_head;
        this.ruleForm.link = notificationData[0].notification_link;
        this.ruleForm.photo = notificationData[0].notification_photo;
        let smallHead = [];
        let label = 0;
        for (var i = 0; i < notificationData.length; i++) {
          let index = notificationData[i].nc_line;
          if (index > smallHead.length) {
            smallHead.push([{ label: label, id: notificationData[i].nc_id, title: notificationData[i].nc_title, value: notificationData[i].nc_content, key: Date.now() }])
          } else {
            smallHead[index - 1].push({ label: label, id: notificationData[i].nc_id, title: notificationData[i].nc_title, value: notificationData[i].nc_content, key: Date.now() })
          }
          label = label + 1;
        }
        this.ruleForm.smallHead = smallHead;
      }).catch(res => {
        this.$alert("查询通知失败!" + res.msg, "提示", {
          confirmButtonText: "确定",
          type: "error"
        });
      });
    },
    clearNotification() {
      this.ruleForm = {
        notification_id: 0,
        bigHead: '',
        link: '',
        photo: '',
        smallHead: [[{ label: 1, id: '', title: '', value: '', key: Date.now() }]]
      }
    }
  }
}
</script>
<style scoped>

</style>